import { CustomScene } from "../models";
import { scenes } from "../scenes";

export default new CustomScene(
  "Knockout",
  scenes.IntroHospital(),
  require("@/audio/Defeat_Jingle.mp3")
);
